<template>
  <div class="container">
    <div class="contents">
      <h1 class="header">
        {{ $t("terms_and_conditions") }}
      </h1>
      <p>
        {{ $t("paragraph1") }}
      </p>
      <p>
        {{ $t("paragraph2") }}
      </p>
      <div
        v-if="!this.$store.state.isReadOnly"
        class="button cta green"
        @click="accept()"
      >
        {{ $t("accept") }}
      </div>
      <div
        v-if="!this.$store.state.isReadOnly"
        class="button skip"
        @click="decline()"
      >
        {{ $t("decline") }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'

export default Vue.extend({
  name: 'TermsAndConditions',
  computed: {
    ...mapGetters([
      'additionalServices'
    ])
  },
  created () {
    this.logEvent('Started viewing terms and conditions page')
  },
  beforeDestroy () {
    this.logEvent('Finished viewing terms and conditions page')
  },
  methods: {
    ...mapMutations([
      'acceptTermsAndConditions',
      'declineTermsAndConditions',
      'logEvent'
    ]),
    accept () {
      this.acceptTermsAndConditions()
      this.$router.push({ name: 'summary' })

      if (this.additionalServices.length) {
        this.$router.push({ name: 'additional-summary' })
      } else {
        this.$router.push({ name: 'summary' })
      }

      this.logEvent('Accepted terms and conditions')
    },
    decline () {
      this.declineTermsAndConditions()

      if (this.additionalServices.length) {
        this.$router.push({ name: 'additional-summary' })
      } else {
        this.$router.push({ name: 'summary' })
      }

      this.logEvent('Declined terms and conditions')
    }
  }
})
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  display: flex;
  justify-content: center;
  .contents {
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    max-width: 768px;
    padding: 1rem;
    .header {
      text-align: center;
    }
    .button {
      width: 100%;
      margin: 1rem 0;
      text-transform: uppercase;
      text-align: center;
    }
    .button.cta {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Futura Heavy';
      line-height: 2rem;
      font-size: 1.8rem;
      font-weight: 400;
      box-shadow: var(--shadow);
      background-color: var(--blue);
      color: var(--white);
      border-radius: 3px;
    }
    .button.cta.green {
      padding: 1rem;
      background-color: var(--green);
    }
    .button.skip {
      color: var(--black);
    }
  }
}
</style>
